import ShipInfoContent from './ShipInfoContent'

export default ShipInfoContent
